/**
 * Configuration des pages SEO locales pour MRG Optique & Audition
 * Chaque clé = slug d'URL (ex: /opticien-istres)
 * Utilisé par LocalSeoPage.js pour générer dynamiquement le contenu et le Schema.org
 */

export const SEO_LOCATIONS = {
  'opticien-istres': {
    slug: 'opticien-istres',
    service: 'opticien',
    city: 'Istres',
    cityPostalCode: '13800',
    h1: 'Opticien à Istres — MRG Optique & Audition',
    headline: 'Votre opticien de confiance au cœur d\'Istres',
    metaTitle: 'Opticien à Istres (13800) — Lunettes, lentilles, examen de vue · MRG Optique',
    metaDescription: 'Opticien à Istres : lunettes de vue, solaires, lentilles, tiers payant mutuelles. +30 grandes marques (Ray-Ban, Persol, Tom Ford). Rendez-vous en ligne. Centre Médical, 44 Chemin du Bord de Crau.',
    heroIntro: 'Découvrez l\'opticien indépendant de référence à Istres. Conseil personnalisé, équipements haut de gamme, tiers payant immédiat avec votre mutuelle.',
    sections: [
      {
        title: 'Lunettes de vue à Istres',
        body: 'Plus de 1000 montures disponibles en boutique : montures acétate, métal, titanium, mémoire de forme. Verres optiques de haute précision (Essilor, Zeiss, Hoya). Adaptation, ajustement et garantie casse incluse.',
        cta: { label: 'Voir les lunettes de vue', href: '/marques' },
      },
      {
        title: 'Lunettes solaires Ray-Ban, Persol, Tom Ford & plus',
        body: 'Sélection pointue des plus grandes marques : Ray-Ban, Persol, Oakley, Tom Ford, Maui Jim, Vuarnet, Police, Carrera. Verres polarisants, photochromiques et solaires correctrices disponibles.',
        cta: { label: 'Découvrir les solaires', href: '/marques' },
      },
      {
        title: 'Lentilles de contact à Istres',
        body: 'Lentilles souples journalières, mensuelles, multifocales et toriques. Adaptation par notre opticien diplômé, essais offerts, livraison à domicile possible.',
        cta: { label: 'Prendre RDV pour un essai lentilles', href: '/rendez-vous' },
      },
      {
        title: 'Tiers payant mutuelles à Istres',
        body: 'Nous travaillons avec toutes les mutuelles (Almerys, Carte Blanche, Itelis, Kalivia, Santéclair, Viamédis). Vous ne réglez que le reste à charge. Devis détaillé gratuit avant achat.',
        cta: { label: 'Vérifier ma mutuelle', href: '/page/mutuelles' },
      },
    ],
    faq: [
      {
        q: 'Où trouver un bon opticien à Istres ?',
        a: 'MRG Optique & Audition est situé au Centre Médical, 44 Chemin du Bord de Crau à Istres (13800). Notre équipe vous accueille du mardi au samedi pour vous conseiller sur le choix de vos lunettes de vue, lunettes solaires ou lentilles de contact.',
      },
      {
        q: 'Quelles mutuelles sont acceptées chez MRG Optique à Istres ?',
        a: 'Nous appliquons le tiers payant immédiat avec la quasi-totalité des mutuelles françaises : Almerys, Carte Blanche, Itelis, Kalivia, Santéclair, Viamédis, et bien d\'autres. Présentez simplement votre carte de mutuelle en magasin.',
      },
      {
        q: 'Faut-il prendre rendez-vous pour un examen de vue ?',
        a: 'Oui, la prise de rendez-vous en ligne est recommandée pour garantir votre créneau et limiter l\'attente. Vous pouvez réserver en quelques clics depuis notre site, 7j/7 et 24h/24.',
      },
      {
        q: 'Combien coûtent des lunettes chez un opticien à Istres ?',
        a: 'Les prix varient selon la monture et les verres choisis. Avec le 100% Santé (panier A), une paire complète peut être intégralement prise en charge par votre mutuelle (0 € à régler). Pour les équipements plus haut de gamme, un devis détaillé vous est remis avant tout engagement.',
      },
      {
        q: 'Proposez-vous un dépannage urgent en cas de casse ?',
        a: 'Oui, nous assurons un service de réparation et dépannage rapide (souvent sous 48h). Si votre paire est totalement irrécupérable, des solutions de remplacement express sont possibles selon stock.',
      },
    ],
    nearbyLinks: [
      { label: 'Audioprothésiste à Istres', href: '/audioprothesiste-istres' },
      { label: 'Opticien à Fos-sur-Mer', href: '/opticien-fos-sur-mer' },
      { label: 'Opticien à Miramas', href: '/opticien-miramas' },
      { label: 'Lunettes de soleil à Istres', href: '/lunettes-de-soleil-istres' },
    ],
  },

  'opticien-fos-sur-mer': {
    slug: 'opticien-fos-sur-mer',
    service: 'opticien',
    city: 'Fos-sur-Mer',
    cityPostalCode: '13270',
    h1: 'Opticien à Fos-sur-Mer (à 15 min d\'Istres)',
    headline: 'L\'expertise MRG Optique à 15 minutes de Fos-sur-Mer',
    metaTitle: 'Opticien à Fos-sur-Mer (13270) — Lunettes, lentilles · MRG Optique Istres',
    metaDescription: 'Habitants de Fos-sur-Mer : votre opticien MRG Optique vous accueille à 15 min à Istres. Lunettes, lentilles, tiers payant mutuelles, +30 grandes marques. Rendez-vous en ligne.',
    heroIntro: 'Vous habitez Fos-sur-Mer ? Notre boutique MRG Optique à Istres, à seulement 15 minutes en voiture, vous propose un large choix de lunettes et de lentilles avec tiers payant immédiat.',
    sections: [
      {
        title: 'Pourquoi venir chez MRG depuis Fos-sur-Mer ?',
        body: 'Conseil personnalisé, sélection pointue des plus grandes marques (Ray-Ban, Persol, Tom Ford, Oakley), examens de vue rapides, tiers payant immédiat avec toutes les mutuelles. Parking gratuit sur place.',
        cta: { label: 'Voir les marques', href: '/marques' },
      },
      {
        title: 'Lunettes de vue et solaires à proximité de Fos-sur-Mer',
        body: 'Plus de 1000 montures en boutique, du modèle iconique au design contemporain. Verres Essilor, Zeiss, Hoya, garantie casse incluse, adaptation et ajustement offerts.',
        cta: { label: 'Découvrir nos lunettes', href: '/marques' },
      },
      {
        title: 'Lentilles de contact et audition à Istres',
        body: 'Lentilles journalières, mensuelles, multifocales. Service audioprothèse pour les habitants de Fos-sur-Mer souhaitant un appareillage auditif.',
        cta: { label: 'Prendre rendez-vous', href: '/rendez-vous' },
      },
    ],
    faq: [
      {
        q: 'Y a-t-il un bon opticien proche de Fos-sur-Mer ?',
        a: 'Oui, MRG Optique & Audition est l\'opticien le plus complet à proximité de Fos-sur-Mer. Situé à Istres (Centre Médical, 44 Chemin du Bord de Crau), à seulement 15 minutes en voiture par la D5.',
      },
      {
        q: 'Le trajet depuis Fos-sur-Mer est-il rapide ?',
        a: 'Comptez environ 15 minutes en voiture depuis le centre de Fos-sur-Mer via la D5. Parking gratuit à proximité immédiate de la boutique.',
      },
      {
        q: 'Mes lunettes peuvent-elles être réparées sur place ?',
        a: 'Oui, nous assurons les petites réparations (vis, plaquettes, ajustement) gratuitement et immédiatement, même si l\'équipement n\'a pas été acheté chez nous.',
      },
    ],
    nearbyLinks: [
      { label: 'Opticien à Istres', href: '/opticien-istres' },
      { label: 'Audioprothésiste à Istres', href: '/audioprothesiste-istres' },
      { label: 'Opticien à Miramas', href: '/opticien-miramas' },
    ],
  },

  'opticien-miramas': {
    slug: 'opticien-miramas',
    service: 'opticien',
    city: 'Miramas',
    cityPostalCode: '13140',
    h1: 'Opticien à Miramas — MRG Optique Istres',
    headline: 'L\'opticien recommandé par les habitants de Miramas',
    metaTitle: 'Opticien à Miramas (13140) — Lunettes & lentilles · MRG Optique',
    metaDescription: 'Habitants de Miramas : votre opticien MRG Optique vous accueille à 10 min à Istres. Lunettes haut de gamme, lentilles, tiers payant mutuelles, prise de rendez-vous en ligne.',
    heroIntro: 'Pour les habitants de Miramas en quête d\'un opticien de confiance, MRG Optique à Istres (à 10 minutes) offre un service personnalisé et une sélection unique de grandes marques.',
    sections: [
      {
        title: 'Un opticien recommandé proche de Miramas',
        body: 'Conseils personnalisés, équipements haut de gamme, tiers payant immédiat avec votre mutuelle. Plus de 30 grandes marques disponibles : Ray-Ban, Persol, Oakley, Tom Ford, Maui Jim.',
        cta: { label: 'Voir nos marques', href: '/marques' },
      },
      {
        title: 'Lentilles & solutions auditives',
        body: 'Service complet : adaptation lentilles, essais offerts, livraison à domicile. Service audioprothèse pour les habitants de Miramas.',
        cta: { label: 'Prendre rendez-vous', href: '/rendez-vous' },
      },
    ],
    faq: [
      {
        q: 'Où trouver un opticien indépendant proche de Miramas ?',
        a: 'MRG Optique & Audition est l\'opticien indépendant le plus proche de Miramas, à seulement 10 minutes en voiture à Istres (Centre Médical, 44 Chemin du Bord de Crau).',
      },
      {
        q: 'Acceptez-vous les mutuelles des habitants de Miramas ?',
        a: 'Oui, toutes les principales mutuelles françaises sont acceptées avec tiers payant immédiat : Almerys, Carte Blanche, Itelis, Santéclair, Viamédis, et bien d\'autres.',
      },
    ],
    nearbyLinks: [
      { label: 'Opticien à Istres', href: '/opticien-istres' },
      { label: 'Audioprothésiste à Istres', href: '/audioprothesiste-istres' },
      { label: 'Opticien à Fos-sur-Mer', href: '/opticien-fos-sur-mer' },
    ],
  },

  'audioprothesiste-istres': {
    slug: 'audioprothesiste-istres',
    service: 'audioprothesiste',
    city: 'Istres',
    cityPostalCode: '13800',
    h1: 'Audioprothésiste à Istres — MRG Optique & Audition',
    headline: 'Solutions auditives sur mesure à Istres',
    metaTitle: 'Audioprothésiste à Istres (13800) — Appareils auditifs · MRG Audition',
    metaDescription: 'Audioprothésiste à Istres : bilan auditif gratuit, appareils auditifs invisibles & rechargeables, prise en charge 100% Santé. Centre Médical, 44 Chemin du Bord de Crau.',
    heroIntro: 'Retrouvez le plaisir d\'entendre. Bilan auditif gratuit, appareils auditifs dernière génération, accompagnement personnalisé par notre audioprothésiste diplômé d\'État.',
    sections: [
      {
        title: 'Bilan auditif gratuit à Istres',
        body: 'Test auditif complet sans engagement, dans un environnement insonorisé. Évaluation de votre audition (audiogramme) et recommandation personnalisée si besoin.',
        cta: { label: 'Prendre RDV pour un bilan', href: '/rendez-vous' },
      },
      {
        title: 'Appareils auditifs invisibles & rechargeables',
        body: 'Les marques de référence : Phonak, Oticon, Signia, Resound, Widex, Starkey. Modèles intra-auriculaires, contour d\'oreille discrets, rechargeables, connectés Bluetooth.',
        cta: { label: 'Découvrir les modèles', href: '/marques' },
      },
      {
        title: '100% Santé — Reste à charge 0 €',
        body: 'Avec le panier 100% Santé, vous pouvez vous équiper sans aucun reste à charge. Devis détaillé gratuit et essai offert avant toute décision.',
        cta: { label: 'En savoir plus', href: '/page/100-sante' },
      },
    ],
    faq: [
      {
        q: 'Le bilan auditif est-il gratuit chez MRG Audition à Istres ?',
        a: 'Oui, le bilan auditif (audiogramme tonal) est entièrement gratuit et sans engagement. Il dure environ 30 minutes et permet d\'évaluer précisément votre audition.',
      },
      {
        q: 'Peut-on essayer un appareil auditif avant achat ?',
        a: 'Oui, nous proposons un essai gratuit de 30 jours après bilan auditif. Vous testez l\'appareil dans votre vie quotidienne avant tout engagement.',
      },
      {
        q: 'Le 100% Santé couvre-t-il vraiment tous les frais ?',
        a: 'Oui, sur le panier 100% Santé (classe I), la prise en charge combinée Sécurité Sociale + mutuelle responsable couvre intégralement l\'appareillage. Reste à charge : 0 €.',
      },
      {
        q: 'Faut-il une ordonnance pour les appareils auditifs ?',
        a: 'Oui, une ordonnance médicale (ORL ou médecin traitant) est obligatoire pour l\'appareillage auditif. Nous pouvons vous orienter vers un ORL partenaire si besoin.',
      },
    ],
    nearbyLinks: [
      { label: 'Opticien à Istres', href: '/opticien-istres' },
      { label: 'Audioprothésiste à Fos-sur-Mer', href: '/audioprothesiste-fos-sur-mer' },
      { label: 'Lentilles de contact à Istres', href: '/lentilles-de-contact-istres' },
    ],
  },

  'audioprothesiste-fos-sur-mer': {
    slug: 'audioprothesiste-fos-sur-mer',
    service: 'audioprothesiste',
    city: 'Fos-sur-Mer',
    cityPostalCode: '13270',
    h1: 'Audioprothésiste à Fos-sur-Mer — MRG Audition à 15 min',
    headline: 'Solutions auditives pour les habitants de Fos-sur-Mer',
    metaTitle: 'Audioprothésiste à Fos-sur-Mer (13270) — Bilan gratuit · MRG Audition',
    metaDescription: 'Habitants de Fos-sur-Mer : audioprothésiste à 15 min à Istres. Bilan auditif gratuit, appareils invisibles, 100% Santé, essai offert 30 jours.',
    heroIntro: 'Pour les habitants de Fos-sur-Mer, notre cabinet d\'audioprothèse à Istres (15 min) propose un suivi auditif complet, dans un cadre médical chaleureux.',
    sections: [
      {
        title: 'Bilan auditif gratuit à proximité de Fos-sur-Mer',
        body: 'Bilan auditif complet dans une cabine insonorisée, à 15 minutes seulement de Fos-sur-Mer. Audiogramme, conseil personnalisé, sans engagement.',
        cta: { label: 'Réserver mon bilan', href: '/rendez-vous' },
      },
      {
        title: 'Appareillage auditif discret & connecté',
        body: 'Phonak, Oticon, Signia, Resound — appareils invisibles, rechargeables, Bluetooth. Adaptation personnalisée et suivi sur 4 ans inclus.',
        cta: { label: 'Voir les modèles', href: '/marques' },
      },
    ],
    faq: [
      {
        q: 'Existe-t-il un audioprothésiste proche de Fos-sur-Mer ?',
        a: 'MRG Optique & Audition propose un service d\'audioprothèse complet à Istres, à seulement 15 minutes en voiture de Fos-sur-Mer via la D5. Bilan auditif gratuit sur rendez-vous.',
      },
      {
        q: 'Combien de temps dure un bilan auditif ?',
        a: 'Environ 30 minutes : audiogramme tonal et vocal, échange sur votre quotidien, recommandation personnalisée. Tout est gratuit et sans engagement.',
      },
    ],
    nearbyLinks: [
      { label: 'Audioprothésiste à Istres', href: '/audioprothesiste-istres' },
      { label: 'Opticien à Fos-sur-Mer', href: '/opticien-fos-sur-mer' },
    ],
  },

  'lunettes-de-soleil-istres': {
    slug: 'lunettes-de-soleil-istres',
    service: 'opticien',
    city: 'Istres',
    cityPostalCode: '13800',
    h1: 'Lunettes de soleil à Istres — Ray-Ban, Persol, Tom Ford',
    headline: 'La plus grande sélection de lunettes solaires à Istres',
    metaTitle: 'Lunettes de soleil à Istres — Ray-Ban, Persol, Oakley · MRG Optique',
    metaDescription: 'Lunettes de soleil à Istres : Ray-Ban, Persol, Oakley, Tom Ford, Maui Jim, Vuarnet. Verres polarisants, solaires correctrices. +30 marques en boutique.',
    heroIntro: 'L\'été, l\'hiver, en montagne ou en bord de mer : trouvez la paire de solaires parfaite parmi nos 30+ marques iconiques.',
    sections: [
      {
        title: 'Ray-Ban, l\'icône intemporelle',
        body: 'Aviator, Wayfarer, Clubmaster, Round — tous les modèles cultes Ray-Ban disponibles en boutique. Verres polarisés Chromance pour une vision nette par tout temps.',
        cta: { label: 'Voir Ray-Ban', href: '/marque/ray-ban' },
      },
      {
        title: 'Persol & Tom Ford — l\'élégance italienne',
        body: 'Persol : montures en acétate Meflecto, charnières en argent. Tom Ford : design audacieux, qualité ultra premium. Pièces rares et collections exclusives.',
        cta: { label: 'Découvrir Persol & Tom Ford', href: '/marques' },
      },
      {
        title: 'Solaires sportives & polarisantes',
        body: 'Oakley, Maui Jim, Vuarnet, Bollé — pour le sport, la conduite, la mer ou la montagne. Verres polarisants et photochromiques disponibles.',
        cta: { label: 'Voir les solaires sport', href: '/marques' },
      },
    ],
    faq: [
      {
        q: 'Où acheter des Ray-Ban authentiques à Istres ?',
        a: 'MRG Optique & Audition est revendeur officiel Ray-Ban à Istres. Tous nos modèles sont authentiques, livrés avec étui d\'origine, chiffon et certificat d\'authenticité.',
      },
      {
        q: 'Peut-on faire mettre des verres correcteurs sur des solaires ?',
        a: 'Oui, la majorité des montures solaires peuvent recevoir des verres correcteurs sur mesure (unifocal, progressifs, polarisants teintés). Devis personnalisé en boutique.',
      },
      {
        q: 'Quelle protection UV est recommandée ?',
        a: 'Privilégiez la catégorie 3 (filtre 82 à 92% de la lumière) pour un usage quotidien, et catégorie 4 (>92%) pour la haute montagne ou les conditions extrêmes. Toutes nos solaires offrent une protection UV400.',
      },
    ],
    nearbyLinks: [
      { label: 'Opticien à Istres', href: '/opticien-istres' },
      { label: 'Lentilles de contact à Istres', href: '/lentilles-de-contact-istres' },
      { label: 'Toutes les marques', href: '/marques' },
    ],
  },

  'lentilles-de-contact-istres': {
    slug: 'lentilles-de-contact-istres',
    service: 'opticien',
    city: 'Istres',
    cityPostalCode: '13800',
    h1: 'Lentilles de contact à Istres — Adaptation & livraison',
    headline: 'Lentilles de contact adaptées à votre vue à Istres',
    metaTitle: 'Lentilles de contact à Istres — Journalières, mensuelles · MRG Optique',
    metaDescription: 'Lentilles de contact à Istres : adaptation par opticien diplômé, essais offerts, livraison à domicile. Lentilles souples journalières, mensuelles, multifocales, toriques.',
    heroIntro: 'Adaptation personnalisée, essais gratuits, livraison à domicile : nos opticiens vous accompagnent dans le choix de vos lentilles de contact.',
    sections: [
      {
        title: 'Lentilles journalières & mensuelles',
        body: 'Acuvue, Air Optix, Biofinity, Dailies — toutes les grandes marques disponibles. Lentilles journalières pour un confort sans entretien, mensuelles pour un usage régulier économique.',
        cta: { label: 'Prendre RDV adaptation', href: '/rendez-vous' },
      },
      {
        title: 'Lentilles multifocales & toriques',
        body: 'Lentilles toriques pour l\'astigmatisme, multifocales pour la presbytie. Adaptation précise par notre opticien diplômé, essai gratuit avant commande.',
        cta: { label: 'Demander un essai', href: '/rendez-vous' },
      },
      {
        title: 'Livraison à domicile à Istres et environs',
        body: 'Commande de renouvellement simple, livraison à domicile dans tout Istres, Fos-sur-Mer, Miramas, Saint-Mitre. Service de rappel automatique pour ne jamais être en rupture.',
        cta: { label: 'Activer le rappel', href: '/rendez-vous' },
      },
    ],
    faq: [
      {
        q: 'Comment se passe l\'adaptation de lentilles à Istres ?',
        a: 'L\'adaptation se fait en 2 rendez-vous : 1) examen, choix du type de lentille, premier essai en magasin (~45 min). 2) contrôle après 7 à 14 jours d\'usage pour valider le confort et la vision.',
      },
      {
        q: 'Combien coûtent les lentilles de contact ?',
        a: 'Comptez environ 25 €/mois pour des lentilles mensuelles, 1 €/jour pour des lentilles journalières. Les forfaits annuels avec livraison à domicile sont plus économiques (-15%).',
      },
      {
        q: 'Faut-il une ordonnance pour des lentilles ?',
        a: 'Oui, une ordonnance valide (de moins de 3 ans pour les adultes, 1 an pour les moins de 16 ans) est nécessaire pour le premier achat. Le renouvellement peut se faire sans nouvelle ordonnance pendant la durée de validité.',
      },
    ],
    nearbyLinks: [
      { label: 'Opticien à Istres', href: '/opticien-istres' },
      { label: 'Lunettes de soleil à Istres', href: '/lunettes-de-soleil-istres' },
      { label: 'Audioprothésiste à Istres', href: '/audioprothesiste-istres' },
    ],
  },
};

export const getSeoLocation = (slug) => SEO_LOCATIONS[slug] || null;
export const allSeoLocations = () => Object.values(SEO_LOCATIONS);
